<template>
  <el-main v-if="user.id">

    <el-card shadow="never">
      <div slot="header">
        <div class="title">
          <span
            >{{ language("awaitDaily_myDailyList.日期") }}：{{ ini() }}</span
          >
          <div>
            <span
              >{{
                language("awaitDaily_myDailyList.最近7天个人未提交日报")
              }}：{{ total }}</span
            >
            <span class="red">{{
              language("awaitDaily_myDailyList.超过7天日报不支持提交")
            }}</span>
          </div>
        </div>
        <div class="state_box">
          <span>筛选：</span>
          <el-button
            :type="index == 0 ? 'primary' : ''"
            @click="changeState('all', '', 0)"
            >{{ language("awaitDaily_myDailyList.全部") }}</el-button
          >
          <el-button
            :type="index == 1 ? 'primary' : ''"
            @click="changeState('submitStauts_and_isAudit', '', 1)"
            >{{ language("awaitDaily_myDailyList.最近7天未提交") }}</el-button
          >
          <el-button
            :type="index == 2 ? 'primary' : ''"
            @click="changeState('awaiItsAudit', 0, 2)"
            >{{ language("awaitDaily_myDailyList.待审核") }}</el-button
          >
          <el-button
            :type="index == 3 ? 'primary' : ''"
            @click="changeState('isAudit', 1, 3)"
            >{{ language("awaitDaily_myDailyList.已审核") }}</el-button
          >
          <el-button
            :type="index == 4 ? 'primary' : ''"
            @click="changeState('submitStatus', 2, 4)"
            >{{ language("awaitDaily_myDailyList.已关闭") }}</el-button
          >
        </div>
      </div>
      <div class="add_wrap">
        <el-button type="primary" @click="add" icon="el-icon-edit">{{
          language("awaitDaily_myDailyList.写日报")
        }}</el-button>
      </div>
        <cc-table
          :loadData="true"
          :config="configTable"
          :params="paramsTable"
          :refeshParams="refeshTable"
          :autoButtonWidth="true"
          :buttonsWidth="60"
          ref="table"
        >
        </cc-table>
    </el-card>

    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="addDialog"
      width="80%"
      append-to-body
    >
      <template v-if="addDialog">
        <edit-my-daily
          :editData="editData"
          @updateData="updateData"
          :type="type"
          @close="addDialog = false"
        ></edit-my-daily>
      </template>
    </el-dialog>
  </el-main>
</template>

<script>
import editMyDaily from "./components/editMyDaily.vue";
import myDailyListStatus from "./components/items/myDailyListStatus.vue";
import moment from "moment";

export default {
  components: {
    editMyDaily,
  },
  data() {
    return {
      user: {},
      total: 0,
      index: 1,
      refeshTable: -1,
      paramsTable: {
        dailyStartTime: this.$timeUtils.getNDay(-6) + " 00:00:00",
        dailyEndTime: this.$timeUtils.getYMMHMS(" 23:59:59"),
        submitStatus: 0,
        userId: "",
        // isAudit: 2,
      },
      configTable: {
        api: "",
        showPager: true,
        columns: [
          {
            prop: "deptName",
            lable: this.language("awaitDaily_myDailyList.部门"),
            minWidth: 100,
          },
          {
            prop: "userName",
            lable: this.language("awaitDaily_myDailyList.提交人"),
            minWidth: 100,
          },
          {
            prop: "dailyTime",
            lable: this.language("awaitDaily_myDailyList.日报日期"),
            minWidth: 160,
            render: (rows) => {
              if (rows.dailyTime) {
                return moment(rows.dailyTime).format("YYYY-MM-DD");
              }
            },
          },
          {
            type: "component",
            prop: "submitStatus",
            lable: this.language("awaitDaily_myDailyList.状态"),
            minWidth: 100,
            componentName: myDailyListStatus,
          },
          {
            prop: "remark",
            lable: this.language("awaitDaily_myDailyList.备注"),
            minWidth: 150,
            render: (row) => {
              if (row.isSubmit == 0) {
                return "超过7天不可填写";
              } else {
                return row.remark;
              }
            },
          },
        ],
        buttons: [
          {
            name: "填写日报",
            click: (row) => {
              this.addDialog = true;
              this.editData = { ...row };
              this.type = "edit";
            },
            check: (rows) => {
              if (rows.dailyTime) {
                let time = new Date().getTime();
                let dailyTime =
                  new Date(rows.dailyTime.replace(/\-/g, "/")).getTime() +
                  604800000;
                if (rows.submitStatus == 0 && time < dailyTime) {
                  return true;
                }
                if (rows.isAudit == 2 && time < dailyTime) {
                  return true;
                }
              }
              return false;
            },
          },
          {
            name: "查看",
            click: (row) => {
              let data = { ...row };

              this.addDialog = true;
              this.editData = { ...data };
              console.log(data);
              this.type = "view";
            },
            check: (row) => {
              if (row.isAudit == 0 && row.submitStatus == 1) {
                return true;
              }
              if (row.isAudit == 1) {
                return true;
              }

              return false;
            },
          },
        ],
      },
      editData: {},
      addDialog: false,
      title: "填写日报",
    };
  },
  methods: {
    ini() {
      let time = new Date();
      let y = time.getFullYear();
      let m = this.count(time.getMonth() + 1);
      let d = this.count(time.getDate());
      return (
        y +
        this.language("awaitDaily_myDailyList.年") +
        m +
        this.language("awaitDaily_myDailyList.月") +
        d +
        this.language("awaitDaily_myDailyList.日")
      );
    },
    count(n) {
      return n < 10 ? "0" + n : n;
    },
    changeState(type, n, index) {
      let paramsTable = {};
      if (type == "all") {
        paramsTable = {};
      }
      paramsTable.userId = this.user.id;

      this.index = index;

      if (type == "submitStauts_and_isAudit") {
        paramsTable["submitStatus"] = 0;
        // this.paramsTable["isAudit"] = 2;
        paramsTable["dailyStartTime"] =
          this.$timeUtils.getNDay(-6) + " 00:00:00";
        paramsTable["dailyEndTime"] = this.$timeUtils.getYMMHMS(" 23:59:59");
        this.getCont();
      } else if (type == "awaiItsAudit") {
        paramsTable["submitStatus"] = 1;
        paramsTable["isAudit"] = 0;
      } else {
        paramsTable[type] = n;
      }
      this.paramsTable = JSON.parse(JSON.stringify(paramsTable));
    },
    add() {
      this.addDialog = true;
      this.editData = {
        isAudit: 0,
        submitStatus: 0,
      };
      this.type = "edit";
    },
    getCont(res) {
      this.paramsTable.userId = this.user.id;
      this.ccRequest
        .do("admin/fsb/workshop/daily/query", this.paramsTable, "GET")
        .then((res) => {
          this.total = res.total;
        });
    },
    updateData() {
      this.getCont();
      this.addDialog = false;
      this.refeshTable = new Date().getTime();
    },
  },
  mounted() {
    this.ccRequest.do("validate", {}, "GET").then((res) => {
      this.getCont(res);
      this.user = res;
      this.configTable.api = "admin/fsb/workshop/daily/query";
      this.paramsTable.userId = this.user.id;
    });
  },
};
</script>
<style scoped lang="scss">
.title {
  font-weight: 700;
  font-size: 18px;
  display: flex;
  align-items: center;
  div {
    margin-left: 20px;
    font-size: 16px;
    display: flex;
    align-items: center;
  }
  .red {
    color: #d6001a;
    font-size: 14px;
    margin-left: 20px;
  }
}
.state_box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 20px 0 0 0;
  span {
    font-weight: 700;
  }
}
.add_wrap {
  margin: 0px 0 20px 0;
}
</style>